/* eslint-disable react-hooks/exhaustive-deps */
import { API, I18n } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { Chip, TextField, MenuItem } from '@material-ui/core';
import { FUNCTION_SETTING, BASIC_SETTING, ADVANCED_SETTING } from '@/common/constant/ModuleSettingVersionConstant';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import { filterLabelByKey, handleOnBlurSystemPromptSetting, validateTextField } from '../../../handler/VersionListHandler';
import Utils from '@/common/utils/utils';
import { HelperText } from '@/component/common/form/input';
import OverFlowTooltipWithCustomCss from '@/component/common/OverFlowTooltipWithCustomCss';
import { getTicketsKnowledgePrompt } from '@/service/ticketService';
import { getProjectById } from '@/service/projectService';
import { openPromptTicketPanel } from '@/component/chatAI/handler/ChatAIHandler';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { setPanelSelector } from '@/state/selector/panelSelector';
import { userAtom } from '@/state/atom/userAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';

function FunctionSetting({
    value,
    setValue,
    setBasicSettingValue,
    setAdvancedSettingValue,
    setIsEdit,
    lincenseKey,
    setLincenseKey,
    setIsChangeLincenseKey,
    isRootSetting,
    setBasicAIPrompt,
    setIsLoading,
    basicAIPrompt,
    systemPrompt,
    setSystemPrompt,
    setIsChangeSystemPrompt,
    defaultSystemPrompt,

    chatGPTModel,
    setChatGPTModel,
    chatGPTModelList,
    knn,
    setKnn,
    minScore,
    setMinScore,
    chatGPTModelDefault,
    knnDefault,
    minScoreDefault,
    inputSystemPrompt,
    setInputSystemPrompt,

    interatorSystemPrompt,
    setInteratorSystemPrompt,
    setIsChangeInteratorSystemPrompt,
    defaultInteratorSystemPrompt,
    inputInteratorSystemPrompt,
    setInputInteratorSystemPrompt,
    ...props
}) {
    const licenseKeyDefault = {...props}.licenseKeyDefault;
    let addNewPanel = useSetRecoilState(setPanelSelector);
    const [userDetail, setUserDetail] = useRecoilState(userAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const handleChangeFunctionSettingValue = (field, option, parent) => {
        switch (field) {
            case 'internalQACounterSettings':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [field]: {
                            ...item[field],
                            value: !option.value
                        }
                    };
                });
                setBasicSettingValue(item => {
                    return {
                        ...item,
                        numberOfQACounters: BASIC_SETTING.numberOfQACounters
                    };
                });
                setAdvancedSettingValue(item => {
                    return {
                        ...item,
                        numberOfAdditionalQACounter: ADVANCED_SETTING.numberOfAdditionalQACounter
                    };
                });
                break;
            case 'deskService':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        internalQACounterSettings: {
                            ...item.internalQACounterSettings,
                            value: !option.value
                        },
                        [parent]: {
                            group: {
                                ...item[parent].group,
                                [field]: {
                                    ...item[parent].group[field],
                                    value: !option.value
                                }
                            }
                        }
                    };
                });
                setBasicSettingValue(item => {
                    return {
                        ...item,
                        numberOfQACounters: BASIC_SETTING.numberOfQACounters,
                        numberOfSupportedCounters: BASIC_SETTING.numberOfSupportedCounters,
                        numberOfB2C: BASIC_SETTING.numberOfB2C
                    };
                });
                setAdvancedSettingValue(item => {
                    return {
                        ...item,
                        numberOfAdditionalQACounter: ADVANCED_SETTING.numberOfAdditionalQACounter,
                        numberOfAdditionalSupportedCounter:
                            ADVANCED_SETTING.numberOfAdditionalSupportedCounter
                    };
                });
                break;
            case 'knowledgeService':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [parent]: {
                            group: {
                                ...item[parent].group,
                                [field]: {
                                    ...item[parent].group[field],
                                    value: !option.value
                                }
                            }
                        }
                    };
                });
                setBasicSettingValue(item => {
                    return {
                        ...item,
                        numberOfKnowledges: BASIC_SETTING.numberOfKnowledges
                    };
                });
                setAdvancedSettingValue(item => {
                    return {
                        ...item,
                        numberOfAdditionalKnowledge: ADVANCED_SETTING.numberOfAdditionalKnowledge
                    };
                });
                break;
            case 'publicWebForm':
            case 'publicService':
            case 'knowledgeBot':
            case 'synonymSearch':
            case 'convertPDF':
            case 'batchCommandService':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [parent]: {
                            group: {
                                ...item[parent].group,
                                [field]: {
                                    ...item[parent].group[field],
                                    value: !option.value
                                }
                            }
                        }
                    };
                });
                break;
            case 'advancedOptionSettings':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [field]: {
                            ...item[field],
                            value: !option.value
                        }
                    };
                });
                setAdvancedSettingValue(ADVANCED_SETTING);
                break;
            case 'chatAI':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [field]: {
                            ...item[field],
                            value: !option.value
                        },
                        lincenseKeyPermission: {
                            value: option.value ? false : item.lincenseKeyPermission.value
                        },
                        aiAuto: {
                            value: option.value ? false : item.aiAuto.value
                        }
                    };
                });
                setSystemPrompt(defaultSystemPrompt);
                setInteratorSystemPrompt(defaultInteratorSystemPrompt);
                setChatGPTModel(chatGPTModelDefault);
                setKnn(knnDefault);
                setMinScore(minScoreDefault);
                setInputSystemPrompt('');
                setInputInteratorSystemPrompt('');
                setLincenseKey(prev => ({
                    ...prev,
                    error: '',
                    value: licenseKeyDefault
                }));
                break;
            case 'lincenseKeyPermission':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [field]: {
                            ...item[field],
                            value: !option.value
                        }
                    };
                });
                setLincenseKey(prev => ({
                    ...prev,
                    error: '',
                    value: licenseKeyDefault
                }));
                break;
            case 'aiAuto':
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [field]: {
                            ...item[field],
                            value: !option.value
                        }
                    };
                });
                setSystemPrompt(defaultSystemPrompt);
                setInputSystemPrompt('');
                setInteratorSystemPrompt(defaultInteratorSystemPrompt);
                setInputInteratorSystemPrompt('');
                break;
            default:
                setIsEdit(true);
                setValue(item => {
                    return {
                        ...item,
                        [field]: {
                            ...item[field],
                            value: !option.value
                        }
                    };
                });
                break;
        }
    };

    const handleDisabled = item => {
        switch (item) {
            case 'publicWebForm':
                return !value.externalServiceDeskSettings.group.deskService.value;
            case 'publicService':
            case 'knowledgeBot':
            case 'synonymSearch':
            case 'convertPDF':
            case 'batchCommandService':
                return !value.knowledgeFunction.group.knowledgeService.value;
            case 'lincenseKeyPermission':
                return !value.chatAI.value;
            case 'aiAuto':
                return !value.chatAI.value;
            default:
                return false;
        }
    };

    const handleChangeInputLincenseKey = (e) => {
        let lincenseKeyValue = e.target.value.trim();
        setIsEdit(true);
        setIsChangeLincenseKey(true);
        setLincenseKey(prev => ({
            ...prev,
            value: lincenseKeyValue,
            error: ''
        }))
    };

    const handleDisableLincenseKeyInput = () => {
        return !value.chatAI.value || !value.lincenseKeyPermission.value;
    };

    const handleDisableSystemPromptInput = () => {
        return !value.chatAI.value || !value.aiAuto.value;
    };

    useEffect(() => {
        if (!value.externalServiceDeskSettings.group.deskService.value) {
            setValue(prev => {
                return {
                    ...prev,
                    externalServiceDeskSettings: { ...FUNCTION_SETTING.externalServiceDeskSettings }
                };
            });
        }

        if (!value.knowledgeFunction.group.knowledgeService.value) {
            setValue(prev => {
                return {
                    ...prev,
                    knowledgeFunction:  { ...FUNCTION_SETTING.knowledgeFunction }
                };
            });
        }
    }, [
        value.externalServiceDeskSettings.group.deskService.value,
        value.knowledgeFunction.group.knowledgeService.value,
    ]);
    const handleBlurTicket = async (e) => {
        if(!e.target.value){
            setBasicAIPrompt({})
        };
        setIsLoading(true)
        const shareLink = e.target.value;
        const pathArray = shareLink?.split('/');
        const affiliationOrganizationDomain = pathArray[4];
        const affiliationProject = pathArray[5];
        const ticketIdOfUrl =  pathArray[7];
        const projectDetail = await getProjectById(API,affiliationProject)
        const res = await getTicketsKnowledgePrompt(API,{
            corporationId: projectDetail.affiliationOrganization,
            projectId: affiliationProject
        })
        const result = Utils.convertJSONDataToObject(res.result);
        const listPrompt = Utils.isEmptyArray(result.listPrompt) ? [] : result.listPrompt
        console.log('listPrompt :>> ', listPrompt);
        const ticketPrompt = listPrompt?.find(ticket => ticket.id === ticketIdOfUrl);
        console.log('ticketPrompt :>> ', ticketPrompt,ticketIdOfUrl);
        setIsEdit(true);
        if(Utils.isEmptyObject(ticketPrompt)){
            setBasicAIPrompt({})
        }else{
            setBasicAIPrompt({id: ticketPrompt.id,
                title: ticketPrompt.title
            })
        };
        setIsLoading(false)
    }

    const renderBasicSetting = () => {
        return (
            <div className="prompt-basic-chip parent-setting-ai-prompt-system">
                {!basicAIPrompt?.id ? (
                    <TextField
                        className="form-control-input form-control-wrapInput form-control-hg32 setting-inputs input-basic-chip setting-version-ai-prompt"
                        variant="outlined"
                        spellCheck={false}
                        autoComplete="seriously-please-don't-autocomplete"
                        type="text"
                        onBlur={async e =>
                            await handleBlurTicket(
                                e
                            )
                        }
                        // helperText={I18n.get(errorBasicPrompt[inputSetting])}
                        // error={!Utils.isEmptyString(errorBasicPrompt[inputSetting])}
                    />
                ) : (
                    <Chip
                        label={<OverFlowTooltipWithCustomCss value={basicAIPrompt.title} />}
                        onClick={()=> {
                            if (Utils.isEmptyObject(basicAIPrompt.id)) return;
                            openPromptTicketPanel(
                                setIsLoading,
                                userDetail,
                                basicAIPrompt.id,
                                projectInuseDetail,
                                props.setIsOpenModalReloadPage,
                                addNewPanel,
                                setIsOpenAccessDeniedPopup
                            );
                        }}
                        onDelete={() => {
                            setBasicAIPrompt({});
                        }}
                        deleteIcon={<img className='basic-chip-delete-icon' src="/assets/image/delete-icon-rounded.svg" alt="delete"/>}
                        className="basic-chip setting-inputs setting-version-ai-prompt"
                    />
                )}
                 <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={I18n.get('KNOWDEMSG005')}
                okCallBack={() => window.location.reload()}
            />
            </div>
        );
    };

    const renderSystemPrompt = (
        systemPromptData,
        setSystemPromptData,
        setIsChangeSystemPromptData,
        setInputSystemPromptData,
        inputSystemPromptData,
        isSystemPrompt
    ) => {
        return (
            <div className={`prompt-basic-chip-ai-auto ${isSystemPrompt ? 'class-system-prompt' : ''}`}>
                {!systemPromptData?.value || (systemPromptData?.value && systemPromptData?.error) ? (
                    <TextField
                        className="form-control-input form-control-wrapInput form-control-hg32 input-basic-chip"
                        variant="outlined"
                        spellCheck={false}
                        autoComplete="seriously-please-don't-autocomplete"
                        type="text"
                        onBlur={async e =>
                            await handleOnBlurSystemPromptSetting(
                                e,
                                API,
                                setIsLoading,
                                systemPromptData,
                                setSystemPromptData,
                                setIsEdit,
                                setIsChangeSystemPromptData
                            )
                        }
                        helperText={I18n.get(systemPromptData.error)}
                        error={!Utils.isEmptyString(systemPromptData.error)}
                        disabled={handleDisableSystemPromptInput()}
                        value={inputSystemPromptData}
                        onChange={(e) => {setInputSystemPromptData(e.target.value)}}
                    />
                ) : (
                    <Chip
                        label={<OverFlowTooltipWithCustomCss value={systemPromptData?.value} placement={'top'}/>}
                        onClick={async ()=> {
                            if (Utils.isEmptyString(systemPromptData?.value)) return;
                            const idTicket = await Utils.getTicketIdByShareLink(systemPromptData?.linkPrompt);
                            openPromptTicketPanel(
                                setIsLoading,
                                userDetail,
                                idTicket,
                                projectInuseDetail,
                                props.setIsOpenModalReloadPage,
                                addNewPanel,
                                setIsOpenAccessDeniedPopup
                            );
                        }}
                        onDelete={() => {
                            if (handleDisableSystemPromptInput()) return true;
                            setSystemPromptData(prev => ({
                                ...prev,
                                error: '',
                                value: '',
                                linkPrompt: ''
                            }))
                            setIsEdit(true);
                            setIsChangeSystemPromptData(true);
                            setInputSystemPromptData('');
                        }}
                        disableRipple={handleDisableSystemPromptInput()}
                        deleteIcon={<img className={`basic-chip-delete-icon ${handleDisableSystemPromptInput() ? 'basic-chip-delete-icon-disable' : ''}`} src="/assets/image/delete-icon-rounded.svg" alt="delete"/>}
                        className={`basic-chip chip-ai-auto ${handleDisableSystemPromptInput() ? 'basic-chip-disable' : ''}`}
                        // disabled={handleDisableSystemPromptInput()}
                    />
                )}
                <ConfirmDialog
                    isOpen={isOpenAccessDeniedPopup}
                    msgConfirm={I18n.get('KNOWDEMSG005')}
                    okCallBack={() => window.location.reload()}
                />
            </div>
        );
    };


    const isDisableAISetting = () => {
        return !value.chatAI.value;
    }

    const handleChangeInputKnn = (e) => {
        let knnValueInput = e.target.value;
        setIsEdit(true);
        setKnn(pre => ({...pre, value: knnValueInput, error: ''}));
    };

    // const handleKeyDownInputKnn = (event) => {
    //     if (['-', '.', 'e'].includes(event.key)) {
    //         event.preventDefault();
    //     }
    // };

    const handleOnBlurInputKnn = (e) => {
        let blurValue = e.target.value

        let rules = [
            {name: 'maxValue', value: 10000},
            {name: 'minValue', value: 1},  
            {name: 'isRequire'},
            {name: 'isNumber'},
        ]
        let fieldKey = 'knn'
        const checkErrorValueInput = validateTextField(rules, blurValue, fieldKey);
        setKnn(pre => ({...pre, value: blurValue.trim(), error: checkErrorValueInput}));
    }

    const handleChangeInputMinScore = (e) => {
        let minScoreInput = e.target.value;
        if (minScoreInput.includes(".")) {
            const [integerPart, decimalPart] = minScoreInput.split(".");

            if (decimalPart && decimalPart.length > 2) {
                return;
            }
        }

        setIsEdit(true);
        setMinScore((pre) => ({ ...pre, value: minScoreInput, error: "" }));
    };

    // const handleKeyDownInputMinScore = (event) => {
    //     if (['-', 'e', '+', ','].includes(event.key)) {
    //         event.preventDefault();
    //     }
    // };

    const handleOnBlurInputMinScore = (e) => {
        let blurValue = e.target.value

        let rules = [
            {name: 'maxValue', value: 1},
            {name: 'minValue', value: 0},
            {name: 'isRequire'},
            {name: 'isDecimal'},
        ]
        let fieldKey = 'minScore'
        const checkErrorValueInput = validateTextField(rules, blurValue, fieldKey);
        setMinScore(pre => ({...pre, value: blurValue.trim(), error: checkErrorValueInput}));
    }

    return (
        <>
            <div className="setting-description border-bottom">
                <span className="description-detail">機能名</span>
                <span className="description-detail">有効/無効</span>
            </div>
            {Object.entries(value).filter(item => !["internalQACounterSettings", "taskManagement"].includes(item[0])).map((item, index) => {
                if (!item[1].group) {
                    switch (item[0]) {
                        case 'chatAI':
                            return (
                                <div className={`setting-item chatAI-item`} key={index}>
                                    <label className="setting-label">{filterLabelByKey(item[0])}</label>
                                    <div className="switch-check">
                                        <input
                                            type="checkbox"
                                            id={`switch-${item[0]}-mode`}
                                            checked={item[1].value}
                                            value={item[1].value}
                                            onChange={() =>
                                                handleChangeFunctionSettingValue(item[0], item[1])
                                            }
                                        />
                                        <label htmlFor={`switch-${item[0]}-mode`}></label>
                                    </div>
                                </div>
                            );
                        case 'lincenseKeyPermission':
                            return (
                                <>
                                    {/* {value.chatAI.value && ( */}
                                        <div className='setting-item-ai-key lincenseKey' key={index}>
                                            <div className="setting-children-item lincenseKeyPermission-item">
                                                <label className="setting-label">{filterLabelByKey(item[0])}</label>
                                                <div className="switch-check">
                                                    <input
                                                        type="checkbox"
                                                        id={`switch-${item[0]}-mode`}
                                                        checked={item[1].value}
                                                        disabled={handleDisabled(item[0])}
                                                        value={item[1].value}
                                                        onChange={() =>
                                                            handleChangeFunctionSettingValue(item[0], item[1])
                                                        }
                                                    />
                                                    <label htmlFor={`switch-${item[0]}-mode`}></label>
                                                </div>
                                            </div>
                                            {false && (
                                                <div className="setting-children-item">
                                                    <HelperText
                                                        error
                                                        text={I18n.get('LABEL-MSG-NOTI-LICENSE-AI')}
                                                        classes='helper-lincenseKey'
                                                    />
                                                </div>
                                            )}
                                            <div className="setting-children-item lincenseKey-input-label-version">
                                                <label className="setting-label">{ProductManagementConstant.TEXTBOX_SETTING_LINCENSE_KEY}</label>
                                            </div>
                                            <div style={{display: 'flex'}}>  
                                                <div className="setting-children-item line-stream"></div>
                                                <TextField
                                                    className="form-control-input form-control-wrapInput form-control-hg32 lincenseKey-input-version"
                                                    variant="outlined"
                                                    spellCheck={false}
                                                    type='text'
                                                    value={lincenseKey.value}
                                                    disabled={handleDisableLincenseKeyInput()}
                                                    onChange={e => handleChangeInputLincenseKey(e)}
                                                    onBlur={e => {
                                                        if (Utils.isEmptyString(e.target.value)) {
                                                            setLincenseKey(prev => ({
                                                                ...prev,
                                                                error: I18n.get('COMMSG014')
                                                            }));
                                                        }
                                                    }}
                                                    onWheel={e => e.target.blur()}
                                                    helperText={lincenseKey.error}
                                                    error={!Utils.isEmptyString(lincenseKey.error)}
                                                />
                                            </div>

                                             {/* CHATGPT_MODEL */}
                                            <div className="setting-children-item lincenseKey-input-label-version">
                                                <label className="setting-label">{I18n.get('ORG-INFOR-LABEL-CHATGPT-MODEL')}</label>
                                            </div>
                                            <div style={{display: 'flex'}}>  
                                                <div className="setting-children-item line-stream"></div>
                                                 <TextField
                                                    // className="form-control form-control--wrap form-control--hg40 width-70"
                                                    className="form-control-input form-control-wrapInput form-control-hg32 width-70 chatGPT-model"
                                                    select
                                                    disabled={isDisableAISetting()}
                                                    variant="outlined"
                                                    name="selectedChatGPTModel"
                                                    value={`${chatGPTModel}`}
                                                    defaultValue={`${chatGPTModel}`}
                                                    SelectProps={{
                                                        value: `${chatGPTModel}`,
                                                        MenuProps: {
                                                            anchorOrigin: {
                                                                vertical: 'bottom',
                                                                horizontal: 'left'
                                                            },
                                                            getContentAnchorEl: null,
                                                            className: 'selectDrop'
                                                        }
                                                    }}
                                                    onChange={e => {
                                                        setChatGPTModel(e.target.value);
                                                        setIsEdit(true);
                                                    }}
                                                >
                                                    {chatGPTModelList.map(chatGPT => {
                                                        return (
                                                            <MenuItem
                                                                key={`chatGPT-${chatGPT.id}`}
                                                                value={chatGPT.id}
                                                            >
                                                                <OverFlowTooltipWithTabsMui
                                                                    className={`className-${chatGPT.id}`}
                                                                    value={chatGPT.id}
                                                                >
                                                                    {chatGPT.id}
                                                                </OverFlowTooltipWithTabsMui>
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </TextField>
                                            </div>

                                            <div className="setting-children-item lincenseKey-input-label-version">
                                                <label className="setting-label">{I18n.get('ORG-INFOR-LABEL-KNN-VALUE')}</label>
                                            </div>
                                            <div style={{display: 'flex'}}>  
                                                <div className="setting-children-item line-stream"></div>
                                                <TextField
                                                    name="knnValue"
                                                    className="form-control-input form-control-wrapInput form-control-hg32 edit-org-input width-70"
                                                    variant="outlined"
                                                    autoComplete="off"
                                                    value={knn.value}
                                                    onChange={e => handleChangeInputKnn(e)}
                                                    onBlur={e => handleOnBlurInputKnn(e)}
                                                    // onKeyDown={e => handleKeyDownInputKnn(e)}
                                                    disabled={isDisableAISetting()}
                                                    type='text'
                                                    helperText={knn.error}
                                                    error={!Utils.isEmptyString(knn.error)}
                                                />
                                            </div>

                                            <div className="setting-children-item lincenseKey-input-label-version">
                                                <label className="setting-label">{I18n.get('ORG-INFOR-LABEL-MIN-SCORE')}</label>
                                            </div>
                                            <div style={{display: 'flex'}}>  
                                                <div className="setting-children-item line-stream"></div>
                                                <TextField
                                                    name="minScore"
                                                    className="form-control-input form-control-wrapInput form-control-hg32 edit-org-input width-70"
                                                    variant="outlined"
                                                    autoComplete="off"
                                                    value={minScore.value}
                                                    onChange={e => handleChangeInputMinScore(e)}
                                                    onBlur={e => handleOnBlurInputMinScore(e)}
                                                    // onKeyDown={e => handleKeyDownInputMinScore(e)}
                                                    disabled={isDisableAISetting()}
                                                    type='text'
                                                    helperText={minScore.error}
                                                    error={!Utils.isEmptyString(minScore.error)}
                                                />
                                            </div>
                                            
                                        </div>
                                    {/* )} */}
                                </>
                            );
                            
                        case 'aiAuto':
                            return (
                                <>
                                    {/* {value.chatAI.value && ( */}
                                        <div className='setting-item-ai-auto border-bottom lincenseKey' key={index}>
                                            <div className="setting-children-item lincenseKeyPermission-item">
                                                <label className="setting-label">{filterLabelByKey(item[0])}</label>
                                                <div className="switch-check">
                                                    <input
                                                        type="checkbox"
                                                        id={`switch-${item[0]}-mode`}
                                                        checked={item[1].value}
                                                        disabled={handleDisabled(item[0])}
                                                        value={item[1].value}
                                                        onChange={() =>
                                                            handleChangeFunctionSettingValue(item[0], item[1])
                                                        }
                                                    />
                                                    <label htmlFor={`switch-${item[0]}-mode`}></label>
                                                </div>
                                            </div>
                                            {false && (
                                                <div className="setting-children-item helper-text">
                                                    <HelperText
                                                        error
                                                        text={I18n.get('LABEL-MSG-NOTI-LICENSE-AI')}
                                                        classes='helper-lincenseKey'
                                                    />
                                                </div>
                                            )}
                                            <div className="setting-children-item lincenseKey-input-label">
                                                <label className="setting-label">{ProductManagementConstant.TEXTBOX_SETTING_SYSTEM_PROMPT}</label>
                                            </div>
                                            <div style={{display: 'flex'}}>  
                                                <div className="setting-children-item line-stream"></div>
                                                {renderSystemPrompt(
                                                    systemPrompt,
                                                    setSystemPrompt,
                                                    setIsChangeSystemPrompt,
                                                    setInputSystemPrompt,
                                                    inputSystemPrompt,
                                                    true
                                                )}
                                            </div>
                                            
                                            <div className="setting-children-item lincenseKey-input-label input-label-ai-auto">
                                                <label className="setting-label">{ProductManagementConstant.TEXTBOX_SETTING_INTERATOR_SYSTEM_PROMPT}</label>
                                            </div>
                                            {renderSystemPrompt(
                                                interatorSystemPrompt,
                                                setInteratorSystemPrompt,
                                                setIsChangeInteratorSystemPrompt,
                                                setInputInteratorSystemPrompt,
                                                inputInteratorSystemPrompt
                                            )}
                                            {/* <TextField
                                                className="form-control-input form-control-wrapInput form-control-hg32 lincenseKey-input"
                                                variant="outlined"
                                                spellCheck={false}
                                                type='text'
                                                value={lincenseKey.value}
                                                disabled={handleDisableLincenseKeyInput()}
                                                onChange={e => handleChangeInputLincenseKey(e)}
                                                onBlur={e => {
                                                    if (Utils.isEmptyString(e.target.value)) {
                                                        setLincenseKey(prev => ({
                                                            ...prev,
                                                            error: I18n.get('COMMSG014')
                                                        }));
                                                    }
                                                }}
                                                onWheel={e => e.target.blur()}
                                                helperText={lincenseKey.error}
                                                error={!Utils.isEmptyString(lincenseKey.error)}
                                            /> */}
                                            {/* <div className="setting-children-item lincenseKey-input-label">
                                                <label className="setting-label">{'システムプロンプト'}</label>
                                            </div>
                                            {renderBasicSetting()} */}
                                           
                                        </div>
                                    {/* )} */}
                                </>
                            );
                        default:
                            return (
                                <div className="setting-item border-bottom" key={index}>
                                    <label className="setting-label">{filterLabelByKey(item[0])}</label>
                                    <div className="switch-check">
                                        <input
                                            type="checkbox"
                                            id={`switch-${item[0]}-mode`}
                                            checked={item[1].value}
                                            value={item[1].value}
                                            onChange={() =>
                                                handleChangeFunctionSettingValue(item[0], item[1])
                                            }
                                        />
                                        <label htmlFor={`switch-${item[0]}-mode`}></label>
                                    </div>
                                </div>
                            );
                    }
                } else {
                    return (
                        <div className="setting-item setting-item-group border-bottom" key={index}>
                            <label className="setting-label">{filterLabelByKey(item[0])}</label>
                            {Object.entries(item[1].group).map((groupItem, i) => {
                                return (
                                    <>
                                        <div
                                            className={`setting-children-item`}
                                            data-group={groupItem[0]}
                                            key={i}
                                        >
                                            <label className="setting-label">
                                                {filterLabelByKey(groupItem[0])}
                                            </label>
                                            <div className="switch-check">
                                                <input
                                                    type="checkbox"
                                                    id={`switch-${groupItem[0]}-mode`}
                                                    checked={groupItem[1].value}
                                                    disabled={handleDisabled(groupItem[0])}
                                                    value={groupItem[1].value}
                                                    onChange={() =>
                                                        handleChangeFunctionSettingValue(
                                                            groupItem[0],
                                                            groupItem[1],
                                                            item[0]
                                                        )
                                                    }
                                                />
                                                <label
                                                    htmlFor={`switch-${groupItem[0]}-mode`}
                                                ></label>
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                        </div>
                    );
                }
            })}
        </>
    );
}

export default FunctionSetting;
